import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query, Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import { difference } from 'lodash';
import ProductForm from '~/components/productForm/productForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import { productValidationSchema } from '../../validation/product';

export const getProductQuery = gql`
  query product($id: Int!) {
    product(id: $id) {
      id
      name
      customsName
      description
      lotPrefix
      costPerLitre
      abv
      volume
      beerStyleId
      hsCodeId
      ingredients {
        id
        ingredientId
        amount
        notes
        measurementType
      }
      variants {
        id
        vesselTypeId
        name
        description
        code
        packagingCost
        taxPerLitre
      }
    }
  }
`;

export const updateProductsMutation = gql`
  mutation updateProduct(
    $id: Int!
    $beerStyleId: Int!
    $name: String!
    $customsName: String
    $description: String
    $lotPrefix: String!
    $abv: Float!
    $costPerLitre: Float!
    $volume: Int!
    $hsCodeId: Int
    $ingredients: [IngredientForProductUpdate]!
    $ingredientIdsToArchive: [Int]
    $variants: [ProductVariantForProductUpdate]
    $variantIdsToArchive: [Int]
  ) {
    updateProduct(
      id: $id
      beerStyleId: $beerStyleId
      name: $name
      customsName: $customsName
      description: $description
      abv: $abv
      costPerLitre: $costPerLitre
      lotPrefix: $lotPrefix
      volume: $volume
      hsCodeId: $hsCodeId
      ingredients: $ingredients
      ingredientIdsToArchive: $ingredientIdsToArchive
      variants: $variants
      variantIdsToArchive: $variantIdsToArchive
    ) {
      id
      name
      description
      abv
      volume
      ingredients {
        id
      }
      variants {
        id
      }
    }
  }
`;

const convertFormValuesIntoUpdateShape = (initialValues, newValues) => {
  const returnValues = { ...newValues };

  // Find the ids that are in the initial values but not in the new values
  // These are for archiving
  const getId = t => t.id;
  returnValues.ingredientIdsToArchive = difference(
    initialValues.ingredients.map(getId),
    newValues.ingredients.map(getId)
  ).filter(t => !!t);

  returnValues.variantIdsToArchive = difference(
    initialValues.variants.map(getId),
    newValues.variants.map(getId)
  ).filter(t => !!t);

  returnValues.ingredients = returnValues.ingredients.map((i, idx) => {
    const ingredient = {
      ...i
    };
    delete ingredient.__typename;
    return ingredient;
  });
  returnValues.variants = returnValues.variants.map((i, idx) => {
    const variant = {
      ...i
    };
    delete variant.__typename;
    return variant;
  });

  returnValues.hsCodeId = returnValues.hsCodeId && !!returnValues.hsCodeId.length ? returnValues.hsCodeId : null;
  return returnValues;
};

export class ProductEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same issue around bad things happening with the Query onCompleted callback
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;
    return (
      <Query query={getProductQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { product } = data;
          return (
            <div className="content">
              <Mutation mutation={updateProductsMutation}>
                {(updateProduct, { error }) => (
                  <Formik
                    initialValues={product}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={productValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateProduct({
                          variables: convertFormValuesIntoUpdateShape(product, values)
                        });
                        history.push(`/products/${id}?updated=true`);
                      } catch (err) {
                        console.log(err);
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={ProductForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(withApollo(ProductEdit));



// WEBPACK FOOTER //
// ./src/containers/productEdit/productEdit.jsx